import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { getTranslationProvider } from '../core/i18n/getTranslationProvider';
import { AuthActions } from '../core/state/auth/auth.actions';
import { AuthSelectors } from '../core/state/auth/auth.selectors';
import { LoginPageComponent } from './login-page.component';

@Component({
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  styles: `
    :host {
      display: block;
      height: 100%;
    }
  `,
  providers: [getTranslationProvider('LoginComponent')],
})
export class LoginComponent extends LoginPageComponent {
  public loggingIn$: Observable<boolean>;

  constructor() {
    super();
    this.loggingIn$ = this.store.select(AuthSelectors.selectLoadSpinnerState);
  }

  public login() {
    this.store.dispatch(AuthActions.legacyInitLogin());
  }
}
